<script setup>
import { onMounted, ref } from 'vue'
import { trackAnalyticsInvestmentProcessStep3 } from '../../../utilities/useTracking'
import InvestmentSummaryTable from '../investmentAmount/InvestmentSummaryTable.vue'
import DisclaimersCheckboxes from '../disclaimers/DisclaimersCheckboxes.vue'
import AcceptPublicInvestmentCheckbox from '../disclaimers/AcceptPublicInvestmentCheckbox.vue'
import AcceptSavingsPlanCheckbox from '../savingsPlan/AcceptSavingsPlanCheckbox.vue'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import DocumentDownloadList from '../documents/DocumentDownloadList.vue'
import InvestmentProcessNavigationButtons from '../InvestmentProcessNavigationButtons.vue'
import { notify } from '../../../utilities/useNotifications'
import { i18n } from '../../../localization'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import BrokerField from '../broker/BrokerField.vue'
import { navigateToNextStep } from '../../../utilities/account/useInvestmentProcessNavigation'
import { storeToRefs } from 'pinia'
import { getPlatformSettings } from '../../../utilities/usePlatformSettings'
import AcceptGiftMembershipCheckbox from '../giftMembership/AcceptGiftMembershipCheckbox.vue'

onMounted(() => {
    trackAnalyticsInvestmentProcessStep3()
})

const store = useInvestmentProcessDataState()
const { allRisksAccepted, brokerNumber, brokerDisclaimer } = storeToRefs(store)

const orderLoading = ref(false)

async function createOrder() {
    if (getCampaignData().asset_data.broker?.broker_field_required && !brokerNumber.value) {
        notify('Error', i18n.global.t('investment_process.please_provide_broker_id'))
    } else if (
        allRisksAccepted.value === false ||
        (getCampaignData().asset_data.broker?.broker_field_required &&
            getCampaignData().asset_data.broker?.broker_disclaimer &&
            !brokerDisclaimer.value)
    ) {
        notify('Error', i18n.global.t('investment_process.please_accept_all_disclaimers'))
    } else {
        orderLoading.value = true

        const orderCreated = await store.createOrder()
        orderLoading.value = false
        if (orderCreated === true) {
            navigateToNextStep()
        }
    }
}
</script>

<template>
    <div class="px-4 py-6 sm:p-6 lg:p-8">
        <InvestmentSummaryTable></InvestmentSummaryTable>
        <AcceptPublicInvestmentCheckbox></AcceptPublicInvestmentCheckbox>
        <AcceptSavingsPlanCheckbox v-if="getCampaignData().asset_data.savings_plan" />
        <AcceptGiftMembershipCheckbox v-if="getPlatformSettings().gift_membership" />
        <DisclaimersCheckboxes show-accept-all-risks></DisclaimersCheckboxes>
        <DocumentDownloadList :documents="getCampaignData().asset_data.contract_data_documents"></DocumentDownloadList>
        <BrokerField v-if="getCampaignData().asset_data.broker?.broker_status" />
        <InvestmentProcessNavigationButtons
            :on-next-click="createOrder"
            :next-button-disabled="orderLoading"
            :next-button-text="$t('investment_process.create_order')" />
    </div>
</template>

<style scoped></style>
